/*
Copyright 2022 Tamal Anwar Chowdhury

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import React, { Component, Fragment } from 'react';
import { elements } from './_data_safety_layout';
import DayDeliveryElement from './DayDeliveryElement';
import '@app/components/sqdp/int/styles/delivery-layout.css';
import dayjs from 'dayjs';
import { getDayColorError, getDayColorGood } from '@app/services/localStorage.service';

class DeliveryLayout extends Component {
  state = {
    showInfo: false,
    element: {},
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 3, 'int');
  };

  getColorOfDay = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0)) {
        return 'emtpy_state';
      }
      let today = dayjs();
      let selectedTime = dayjs(this.props.selectedMonth);
      if (
        today.get('month') <= selectedTime.get('month') &&
        today.get('year') <= selectedTime.get('year') &&
        dateNum > today.get('date')
      ) {
        return 'emtpy_state';
      }

      if (
        (!issueOfDay.countSafetyIsStopDeliver || issueOfDay.countSafetyIsStopDeliver <= 0) &&
        (!issueOfDay.countQualityIsStopDeliver || issueOfDay.countQualityIsStopDeliver <= 0) &&
        (!issueOfDay.countProductivityIsStopDeliver || issueOfDay.countProductivityIsStopDeliver <= 0) &&
        (!issueOfDay.countDeliveryTotal || issueOfDay.countDeliveryTotal <= 0)
      ) {
        return 'green_state';
      } else {
        return 'red_state';
      }
    }

    return 'emtpy_state';
  };

  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDay = this.props.dataInMonth[i - 1];
      let color = this.getColorOfDay(issueOfDay, i);
      items.push(
        <DayDeliveryElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          num={i}
          color={color}
          issues={issueOfDay}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      // <div className="wrapper">
      <>
        <div id="table-delivery">
          {/* Elements 1-4 */}
          {this.populateElements(1, 32)}
          {/* Information Table */}
          {/* {this.state.showInfo && (
            <Fragment>
              <div id="element-box" className={`${category}`}>
                <div className="number">{number}</div>
                <div className="symbol">{symbol}</div>
                <div className="element-name">{name}</div>
              </div>
              <div id="information">
                <div
                  onClick={this.closeInfo}
                  className="close-button"
                  title="Close Info"
                >
                  Close [&times;]
                </div>
                <div>
                  <h1 className="big_title">{name}</h1>
                  <span className={`cat_name ${category}`}>{category}</span>
                  {appearance && (
                    <div className="appearance">
                      <strong>Appearance:</strong> {appearance}
                    </div>
                  )}
                  <div className="atom_info">
                    <span>Atomic Mass: {atomic_mass} | </span>
                    <span>Density: {density}</span>
                    {molar_heat && <span> | Molar Heat: {molar_heat}</span>}
                    {melt && <span> | Melt: {melt}K</span>}
                    {boil && <span> | Boil: {boil}K</span>}
                  </div>
                  <div>
                    {summary} ...{" "}
                    <a target="_blank" href={source}>
                      Source
                    </a>
                  </div>
                </div>
              </div>
            </Fragment>
          )} */}

          {/* {this.populateElements(5, 57)}
          {this.populateElements(72, 89)}
          {this.populateElements(104, 118)}
          {this.populateElements(58, 71)}
          {this.populateElements(90, 103)} */}
        </div>
        <h3 className="center" style={{ paddingLeft: '30px', marginTop: '20px' }}>
          Delivery
        </h3>
      </>
    );
  }
}

export default DeliveryLayout;
